"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Tooltip_1 = __importDefault(require("react-bootstrap/Tooltip"));
var OverlayTrigger_1 = __importDefault(require("react-bootstrap/OverlayTrigger"));
var Tooltip = function (props) {
    var children = props.children, className = props.className, _a = props.placement, placement = _a === void 0 ? 'top' : _a, value = props.value;
    var tooltip = react_1.default.createElement(StyledTooltip, { id: "tooltip" }, value);
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(OverlayTrigger_1.default, { placement: placement, overlay: tooltip }, children)));
};
exports.Tooltip = Tooltip;
var StyledTooltip = (0, styled_components_1.default)(Tooltip_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 1rem;\n  display: block;\n"], ["\n  font-size: 1rem;\n  display: block;\n"])));
exports.default = exports.Tooltip;
var templateObject_1;
